import revive_payload_client_4sVQNw7RlN from "/var/www/orthofresh2/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/orthofresh2/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/orthofresh2/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_7pzUtwM1Zj from "/var/www/orthofresh2/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/var/www/orthofresh2/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/orthofresh2/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/var/www/orthofresh2/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/orthofresh2/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/var/www/orthofresh2/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/orthofresh2/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import vuetify_7h9QAQEssH from "/var/www/orthofresh2/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_7pzUtwM1Zj,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  chunk_reload_client_UciE0i6zes,
  vuetify_7h9QAQEssH
]